import HiddenFields from './hidden-fields'

const AuthForm = ({ action, method = 'post', children }) => {
	return (
		<form
			method={method}
			action={action}
		>
			<HiddenFields/>
			{children}
		</form>
	)
}

export default AuthForm
